import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';

import CustomerSurveyform from './CustomerSurveyform'
class App extends Component{
render()
{
  return(
    <div className='App'>
      <CustomerSurveyform />
    </div>
  )
}

}
export default App;
